import { Style } from 'inlines'
import Column from '@app/components/layout/Column'
import { Text } from '@app/components/core/typography/Text'
import { ReactNode } from 'react'

export type NavBarItemProps = {
  children: ReactNode
  label: string
  toggled: boolean
  style?: Style
  onClick?: VoidFunction
}

export const NavBarItem = ({
  children,
  label,
  toggled,
  style,
  onClick,
}: NavBarItemProps) => {
  return (
    <Column
      gap="0.25"
      alignItems="center"
      onClick={onClick}
      style={{
        ...style,
        cursor: 'pointer',
        position: 'relative',
      }}
    >
      {children}
      <Text.ExtraSmall
        color={toggled ? 'var(--primary-blue)' : 'var(--shades-blue-500)'}
        style={{
          whiteSpace: 'nowrap',
          position: 'absolute',
          top: '100%',
        }}
      >
        {label}
      </Text.ExtraSmall>
    </Column>
  )
}
